import { useLocation } from 'react-router-dom';
import { DynamicIsland } from '@/shared/components/DynamicIsland';
import { useDynamicIslandNotifications } from '@/shared/hooks/useDynamicIslandNotifications';
import { StreakWidget } from '@/shared/components/StreakWidget';

/**
 * DesktopTopBar - A minimal top bar for desktop that shows active cycle and notifications
 * Only visible on large screens (lg+)
 * Hidden on certificate editor pages to avoid overlapping with editor toolbar
 */
export function DesktopTopBar() {
  const location = useLocation();
  const {
    unreadNotifications,
    handleNotificationClick,
    handleNotificationDismiss,
  } = useDynamicIslandNotifications();

  // Hide on certificate editor pages
  const isEditorPage = location.pathname.includes('/certificados/plantillas/editor');

  if (isEditorPage) {
    return null;
  }

  return (
    <>
      {/* Streak Widget - Fixed top right */}
      <div className="hidden lg:block fixed top-4 right-6 z-50">
        <StreakWidget size="md" />
      </div>

      {/* Dynamic Island - Centered */}
      <DynamicIsland
        className="hidden lg:block"
        notifications={unreadNotifications}
        onNotificationClick={handleNotificationClick}
        onNotificationDismiss={handleNotificationDismiss}
        position="top"
        alignment="center"
        autoExpand={true}
        autoCycle={true}
      />
    </>
  );
}
